module.exports = __webpack_public_path__ + "static/media/lds-logo_es.d840d969.svg";